<template>
  <a-cascader
      v-model:value="areaSelect"
      :allowClear="false"
      :fieldNames="{ label: 'label', value: 'value', children: 'children' }"
      :load-data="areaLoadData"
      :options="areaOptions"
      :placeholder="placeholder"
      style="width: 100%"
      @change="changeSelect"
      @popup-visible-change="getAreaData"
  ></a-cascader>
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";
import {getArea} from "@/api/api";

export default {
  props: {
    placeholder: {
      default: "请选择所在区域",
    },
    areaValue: {
      default: null,
    },
  },
  setup(props, context) {
    let area = reactive({
      areaSelect: [],
      placeholder: props.placeholder,
      areaOptions: [], //区域选项数据
      getAreaData() {
        if (!area.areaOptions.length) {
          getArea({
            LevelType: 1,
            ParentId: 100000,
          }).then((res) => {
            area.areaOptions = res.data.map((item) => {
              item.isLeaf = false;
              return item;
            });
          });
        }
      },
      areaLoadData(params) {
        const targetOption = params[params.length - 1];
        targetOption.loading = true;
        let LevelType = params.length + 1;
        getArea({
          LevelType: LevelType,
          ParentId: targetOption.value,
        }).then((res) => {
          targetOption.children = res.data.map((item) => {
            item.isLeaf = LevelType == 3 ? true : false;
            return item;
          });
          targetOption.loading = false;
        });
      },
      changeSelect(value, selectedOption) {
        const params = {
          province_id: value[0] ? value[0] : "",
          city_id: value[1] ? value[1] : "",
          area_id: value[2] ? value[2] : "",
          province_name: selectedOption[0] ? selectedOption[0].label : "",
          city_name: selectedOption[1] ? selectedOption[1].label : "",
          area_name: selectedOption[2] ? selectedOption[2].label : "",
        };
        console.log(area.areaSelect);
        context.emit("changeArea", params);
      },
    });

    onMounted(() => {
    });

    return {
      ...toRefs(area),
    };
  },
};
</script>

<style>
</style>
